export default __webpack_public_path__ + "static/media/googlecloud.e4d9ae81.png";